<template>
  <div class="card-table">
    <el-table :data="tableData.list || []" style="width: 100%">
      <el-table-column :key="key" :label="keyTxt[key] && keyTxt[key].txt" :prop="key"
                       :width="keyTxt[key] && keyTxt[key].width" v-for="key in tableData.keyList">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  //需要的字段和数据都需要传入
  export default {
    data() {
      return {
        pageSize: 2,
        keyTxt: {
          name: {
            txt: '',
            width: 103*1.25
          },
          salesAmount: {
            txt: '销售金额',
            width: 120*1.25
          },
          commission: {
            txt: '佣金',
            width: 90*1.25
          },
          paidOrderCount: {
            txt: '付费订单数',
            width: 127*1.25
          },
          // paidUserCount: {
          //   txt: '付费用户数',
          //   width: 144*1.25
          // },
          lockSalesAmount: {
            txt: '销售金额',
            width: 120*1.25
          },
          lockCommission: {
            txt: '佣金',
            width: 90*1.25
          },
          lockPaidOrderCount: {
            txt: '付费订单数',
            width: 127*1.25
          },
          // lockPaidUserCount: {
          //   txt: '付费用户数',
          //   width: 144*1.25
          // }
        }
      }
    },
    props: ['tableData', 'pagSearch']
  }
</script>

<style lang="scss" scoped>
  .el-table::before {
    background: #e8e8e8;
  }
</style>



// WEBPACK FOOTER //
// table.vue?349b6bba